import { GridVirtualScroller } from '../virtualization/GridVirtualScroller';

export { GridVirtualScroller as GridBody };
